import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { IFormErrors } from '@interfaces/IFormsErrors';
import { INotUploadedWorks } from '@interfaces/IWorkDebtors';
import { IAppState } from '@myStore/app.state';
import { IGroupFormErrors } from '@myStore/groups/groups.state';
import {
  AddWorkDebtorsRequest,
  ClearAddWorkDebtorsErrors,
} from '@myStore/work-debtors/work-debtors.actions';
import {
  selectAddWorkDebtorsFailure,
  selectWorkDebtorsLoadingChanges,
} from '@myStore/work-debtors/work-debtors.selector';
import { select, Store } from '@ngrx/store';
import { FormDialogComponent } from '@shared/components/UI/form-dialog/form-dialog.component';
import { isControlsIsValid } from '@shared/utils/formUtils';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-student-work-note-form',
  templateUrl: './student-work-note-form.component.html',
  styleUrls: ['./student-work-note-form.component.sass'],
})
export class StudentWorkNoteFormComponent implements OnInit, OnDestroy {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  readonly requiredErrorMessage = 'Поле является обазательным';
  public dialogData = this.dialogRef.componentInstance.data;
  public workList: INotUploadedWorks[] = [];
  public checkedWorks = new Set<number>();
  public loadingSubmit = this._store.pipe(
    select(selectWorkDebtorsLoadingChanges)
  );
  public errors$: IFormErrors | null = null;
  public deductionForm = new UntypedFormGroup({
    text: new UntypedFormControl(''),
  });

  constructor(
    private _store: Store<IAppState>,
    public dialogRef: MatDialogRef<FormDialogComponent>
  ) {}

  ngOnInit(): void {
    if (this.dialogData.list) {
      this.workList = this.dialogData.list;
    }

    this._store
      .pipe(select(selectAddWorkDebtorsFailure), takeUntil(this.destroy$))
      .subscribe(errors => {
        this.errors$ = errors;
        this.setControlErrors(errors);
      });
  }

  toggleCheckWork(id: number): void {
    this.checkedWorks.has(id)
      ? this.checkedWorks.delete(id)
      : this.checkedWorks.add(id);
  }

  onCancel() {
    this.dialogRef.close();
  }

  isButtonDisabled(): boolean {
    return (
      this.checkedWorks.size === 0 || !this.deductionForm.controls.text.value
    );
  }

  get text() {
    return this.deductionForm.get('text');
  }

  setControlErrors(errors: IGroupFormErrors | null): void {
    if (errors) {
      Object.keys(errors).forEach(key => {
        if (this.deductionForm.controls[key]) {
          this.deductionForm.controls[key].setErrors({ errors: errors[key] });
        }
      });
    }
  }

  getMessageFormError(name: string): string | null {
    if (this.errors$ && this.errors$[name]) {
      return this.errors$[name][0];
    }

    return null;
  }

  onSubmit() {
    if (this.checkedWorks.size === 0) return;

    if (isControlsIsValid(this.deductionForm.controls)) {
      const data = {
        group_id: this.dialogData.groupId ? this.dialogData.groupId : 0,
        student_id:
          this.dialogData.student && this.dialogData.student.id
            ? this.dialogData.student.id
            : 0,
        text: this.deductionForm.controls.text.value,
        not_uploaded_works: [...this.checkedWorks],
      };

      this._store.dispatch(new AddWorkDebtorsRequest(data));
    }
  }

  ngOnDestroy() {
    this._store.dispatch(new ClearAddWorkDebtorsErrors());
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
